import React from 'react';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import helpers from '../utils/fieldsHelper';
/**
 * @param {{error?:string, description?:string}} param
 */

var Description = function Description(_ref) {
  var error = _ref.error,
      description = _ref.description;
  var descriptionContent = description ? React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: helpers.getHtmlMarkup(description)
    }
  }) : '';
  if (!error && !description) return React.createElement(FormHelperText, {
    margin: "dense"
  }, React.createElement(Typography, null, " "));
  return (error || description) && React.createElement(FormHelperText, {
    error: !!error,
    margin: "dense",
    className: error ? 'error-block' : 'help-block'
  }, error || descriptionContent || ' ');
};

export default Description;